<template>
    <v-card v-if="!isInvestment">
        <v-card-title class="d-flex justify-center">
            <p class="cyan--text text--darken-1" style="font-size: 20px;">{{ company && company.deal_status === 'New' ? 'DEAL REVIEW' : 'DEAL DETAIL' }}</p>
            <div class="close-icon" style="cursor: pointer; position: absolute; right: 20px; top: 20px;" @click="closeModal">
                X
            </div>
        </v-card-title>

        <v-card-text style="height: 760px;" class="scrollbar" id="scrollbar">
            <div class="container" v-if="company">
                <div class="d-flex flex-column flex-md-row justify-content-between align-items-center py-4 px-8" style="background: #c5e7ec; gap: 20px;">
                    <div class="d-flex justify-start align-items-center mt-4" style="gap: 50px;">
                        <img
                            :src="baseUrl + company.company.logo"
                            alt="logo"
                            style="width: 60px; height: 60px;"
                            @error="handleImageError"
                        />
                        <div class="text-left">
                            <p style="color: #000">DEAL ID: {{ company.id }}</p>
                            <p style="color: #000">{{ company.company.company_name }}</p>
                        </div>
                    </div>
                    <p style="color: #000">Status: <span :style="company.deal_status === 'New' ? 'color: #FF9E3A' : 'color: green'">{{ company.deal_status }}</span></p>
                </div>

                <div>
                    <b-card no-body>
                        <b-tabs card>
                            <b-tab title="Main Contact" active @click="setSection('mainContact')">
                                <MainContact
                                    :companyId="company.company.id"
                                    :userId="company.company.user_id"
                                    :fromReview="true"
                                    v-if="section == 'mainContact'"
                                />
                                <br />
                            </b-tab>

                            <b-tab title="Company Profile" @click="setSection('companyProfile')">
                                <CompanyProfile
                                    :company_id="company.company.id"
                                    :fromReview="true"
                                    v-if="section == 'companyProfile'"
                                />
                            </b-tab>

                            <b-tab title="Legal Representatives" @click="setSection('legalRepresentatives')">
                                <LegalRepresentative
                                    :company_id="company.company.id"
                                    :fromReview="true"
                                    v-if="section == 'legalRepresentatives'"
                                />
                            </b-tab>

                            <b-tab title="Team" @click="setSection('team')">
                                <FounderTeam
                                    :company_id="company.company.id"
                                    :fromReview="true"
                                    v-if="section == 'team'"
                                />
                            </b-tab>

                            <b-tab title="Product" @click="setSection('product')">
                                <Product
                                    :company_id="company.company.id"
                                    :fromReview="true"
                                    v-if="section == 'product'"
                                />
                            </b-tab>

                            <b-tab title="Finance History" @click="setSection('financeHistory')">
                                <FinanceHistory
                                    :company_id="company.company.id"
                                    :fromReview="true"
                                    v-if="section == 'financeHistory'"
                                />
                            </b-tab>

                            <b-tab title="Funding Needs" @click="setSection('fundingNeeds')">
                                <FundingNeeds
                                    :company_id="company.company.id"
                                    :fromReview="true"
                                    v-if="section == 'fundingNeeds'"
                                />
                            </b-tab>
                        </b-tabs>
                    </b-card>
                </div>
            </div>
        </v-card-text>

        <v-divider></v-divider>
        <v-card-actions class="d-flex justify-content-center text-center" center>
            <div style="gap: 15px" v-if="company">
                <p style="color: #5ae6ff;">{{ company.deal_status === 'Interested' ? 'Update on the progress' : company.deal_status === 'Investment' ? 'Still in your investment porfolio ?' : 'Interested to meet the team ?' }}</p>

                <div class="d-flex justify-content-center align-items-center" style="gap: 10px;" v-if="company.deal_status !== 'New'">
                    <v-autocomplete
                        v-model="dealStatus"
                        :items="getNextStatuses(company.deal_status)"
                        outlined
                        dense
                        class="m-0"
                    />
                    <button class="btn btn-primary mt-n7 py-2 px-5" @click="updateToOtherStatus">{{ add_deal_loader ? "Updating..." : "Update" }}</button>
                </div>
                <div class="d-flex justify-content-center align-items-center text-center" style="gap: 20px" v-if="company.deal_status === 'New'">
                    <div v-if="company">
                        <img
                            alt="Disabled icon"
                            src="../../../../assets/img/a-3.png"
                            height="43"
                            width="43"
                            style="cursor: not-allowed;"
                            v-if="company.deal_status === 'Interested'"
                        />
                        <img
                            alt="Add this deal in my deal flow"
                            src="../../../../assets/img/a-1.png"
                            height="43"
                            width="43"
                            :class="company.deal_status === 'Interested' ? 'd-none' : ''"
                            @click="updateDealStatusToInterested"
                            style="cursor: pointer;"
                            v-if="!add_deal_loader"
                        />
                        
                        <div v-else class="spinner-border text-secondary mt-2" role="status">
                            <span class="sr-only">Loading...</span>
                        </div>
                    </div>

                    <img
                        alt="Close deal"
                        src="../../../../assets/img/a-2.png"
                        height="43"
                        width="43"
                        @click="reviewModal = false"
                        style="cursor: pointer;"
                    />
                </div>
            </div>
        </v-card-actions>
    </v-card>

    <v-card v-else>
        <Investment
            :companyId="company.company.id"
            :dealId="company.id"
            :myCompany="company"
            :closeConfirmModal="closeConfirmModal"
            :getAllCompaniesDeals="getAllCompaniesDeals"
        />
    </v-card>
</template>
<script>
    import Company from '@/store/services/company/company.service.js'
    import Chat from '@/store/services/chat/chat.service.js'
    import MainContact from '@/components/Dashboard/MainContact.vue'
    import CompanyProfile from '@/components/Dashboard/CompanyProfile.vue'
    import FounderTeam from '@/components/Dashboard/FoundingTeam.vue'
    import Product from '@/components/Dashboard/TypeOfBusiness.vue'
    import FinanceHistory from '@/components/Dashboard/FinanceHistory.vue'
    import FundingNeeds from '@/components/Dashboard/FundingNeeds.vue'
    import LegalRepresentative from '@/components/Dashboard/LegalRepresentative.vue'
    import Investment from './Investment.vue'
    import { myMixins } from "@/mixins/mixins.js";

    export default {
        mixins: [myMixins],
        components: {
            LegalRepresentative,
            CompanyProfile,
            FounderTeam,
            Product,
            FinanceHistory,
            FundingNeeds,
            MainContact,
            Investment
        },
        props: {
            closeModal: Function,
            company: Object,
            currentUserId: Number,
            baseUrl: String,
            getAllCompaniesDeals: Function,
        },
        data() {
            return {
                dealStatus: null,
                add_deal_loader: false,
                dealStatusItems: [
                    'Interested',
                    'Deep dive',
                    'Due Diligence',
                    'Deal Negotiation',
                    'Closing',
                    'Investment',
                    'Negotiation Cancelled',
                    'Exit'
                ],
                section: 'mainContact',
                isInvestment: false,
            }
        },
        methods: {
            formatDate (date) {
                let dat = new Date(date);
                let year = dat.getFullYear();
                let month = dat.getMonth() + 1;
                let day = dat.getDate();
                if(day < 10 && month < 10){
                    return `0${day}/0${month}/${year}`;
                }
                else if (month < 10) {
                    return `${day}/0${month}/${year}`;
                }
                else{
                    return `${day}/${month}/${year}`;
                }
            },

            capitalizeFLetter (string) {
                let value = string?.replace("_", " ");
                let str = value?.toLowerCase() || null;
                return str?.replace(/^./, str[0].toUpperCase());
            },

            getNextStatuses(currentStatus) {
                let updatedDealStatusItems = [...this.dealStatusItems];

                if (currentStatus === 'Investment') {
                    updatedDealStatusItems = updatedDealStatusItems.filter(status => status !== 'Negotiation Cancelled');
                }

                const currentIndex = updatedDealStatusItems.indexOf(currentStatus);

                if (currentIndex !== -1) {
                    return updatedDealStatusItems.slice(currentIndex + 1);
                } else {
                    return [];
                }
            },

            updateToOtherStatus () {
                if (!this.dealStatus) {
                    this.$toast.open({
                        message: "Status is not set, please set it before updating",
                        type: 'info',
                        position: 'top-right',
                        hasIcon: true
                    });
                    this.add_deal_loader = false;
                    return
                }
                this.add_deal_loader = true;
                let data = {
                    deal_status: this.dealStatus
                }

                if (this.dealStatus == 'Investment') {
                    this.isInvestment = true;
                } else {
                    Company.updateToHighStatus(data, this.company.id).then((res) => {
                    this.$toast.open({
                        message: res.data.message,
                        type: 'success',
                        position: 'top-right',
                        duration: 3000,
                        hasIcon: true
                    });
                    this.closeModal()
                    this.getAllCompaniesDeals()
                    this.add_deal_loader = false;
                }).catch((e) => {
                    this.add_deal_loader = false;
                    this.$toast.open({
                        message: e.response.data.message,
                        type: 'error',
                        position: 'top-right'
                    });
                });
                }
            },

            updateDealStatusToInterested () {
                this.add_deal_loader = true;
                let data = {
                    deal_status: 'Interested',
                }
                Company.updateDealStatus(data, this.company.id).then((res) => {
                    if (res.status == 200) {
                        this.$toast.open({
                            message: res.data.message,
                            type: 'success',
                            position: 'top-right',
                            hasIcon: true
                        });
                        this.closeModal();
                        this.getAllCompaniesDeals()
                        const data = {
                            to: this.currentUserId,
                            conversation: "Hello, I am interested in learning more about your company and participating in your current investment round. Thank you in advance for getting back to me.",
                            activated: 1
                        }
                        Chat.saveConversation(data).then(() => {
                            console.log("");
                        }).catch((e) => {
                            this.$toast.open({
                                message: e.response.data.message,
                                type: 'error',
                                position: 'top-right',
                                hasIcon: true
                            });
                        });
                    }
                    this.add_deal_loader = false;
                }).catch(() => {
                    this.add_deal_loader = false;
                })
            },

            setSection(section) {
                this.section = section;
            },

            closeConfirmModal () {
                this.isInvestment = false;
                this.add_deal_loader = false;
                this.closeModal()
            }
        },
    }
</script>